import { useEffect } from "react";
import { EventService, mergeDeep } from "@perxis-auto/shared";
import { useFilterValues } from "../../filterValues/lib/api/hooks/useFilterValues.js";
import "../../../shared/config/env.js";
import { APP_EVENTS } from "../../../shared/config/events.js";
import { useQueryParams } from "../../../shared/lib/query/hooks/useQueryParams.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import { selectFilterGridItems } from "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import { selectFilters as selectFilters$1 } from "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import { selectSort } from "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import { selectFilters } from "../../../shared/store/installation/model/selectors/selectFilters.js";
import { actions as actions$2 } from "../../../shared/store/installation/model/slice.js";
import { getOffsetQueryValue } from "../../../shared/store/pagination/lib/getOffsetQueryValue.js";
import { actions as actions$1 } from "../../../shared/store/pagination/model/slice.js";
import "../model/middleware/index.js";
import "../model/selectors/selectFilterHistory.js";
import "../model/selectors/selectFilterSortValue.js";
import "../model/selectors/selectFilterValuesCount.js";
import "../model/selectors/selectIsFilterValuesSelected.js";
import "../model/selectors/selectIsInitialSortValuesSelected.js";
import "../model/selectors/selectIsValidSortValuesSelected.js";
import "../model/selectors/selectSlugedFilterValues.js";
import { actions } from "../model/slice.js";
import { getFiltersInitialValues } from "./getFiltersInitialValues.js";
import { getFiltersQueryValues } from "./getFiltersQueryValues.js";
import { getSortQueryValue } from "./getSortQueryValue.js";
const useFilterSettings = () => {
  const dispatch = useAppDispatch();
  const eventService = EventService.getInstance();
  const queryParams = useQueryParams();
  const { ready: filtersReady } = useAppSelector(selectFilters);
  const { initialValues: filtersInitialValues } = useAppSelector(selectFilters$1);
  const filterGridItems = useAppSelector(selectFilterGridItems);
  const { initialValues: sortInitialValues, items: sortItems } = useAppSelector(selectSort);
  const { isSuccess, data: filterValuesItem } = useFilterValues();
  useEffect(() => {
    if (!filtersReady && isSuccess) {
      const initialValues = getFiltersInitialValues(filtersInitialValues, filterGridItems, filterValuesItem);
      const queryValues = getFiltersQueryValues(queryParams, filterGridItems, filterValuesItem);
      const mergedValues = mergeDeep(queryValues, initialValues);
      const offset = getOffsetQueryValue(queryParams);
      const sort = getSortQueryValue(queryParams, sortItems, sortInitialValues);
      if (Object.keys(mergedValues).length !== 0) {
        dispatch(actions.setValues(mergedValues));
      }
      if (!!sort && !!sort.length) {
        dispatch(actions.setSort(sort));
      }
      if (offset) {
        dispatch(actions$1.setOffset(offset));
      }
      dispatch(actions$2.setFiltersReady(true));
      eventService.sendEvent(APP_EVENTS.FiltersReady);
    }
  }, [isSuccess]);
};
export {
  useFilterSettings
};
